"use strict";
// tslint:disable:max-file-line-count
Object.defineProperty(exports, "__esModule", { value: true });
exports.exerciseNeeds = exports.trainability = exports.healthGrooming = exports.friendliness = exports.adaptability = exports.charactersticInformation = void 0;
var profile_1 = require("../schemas/profile");
exports.charactersticInformation = {
    adaptsWellToApartmentLiving: {
        name: 'Adapts Well to Apartment Living',
        description: "Contrary to popular belief, small size doesn't necessarily an apartment dog make \u2014 plenty of small \n    dogs are too high-energy and yappy for life in a high-rise. Being quiet, low energy, fairly calm indoors, and \n    polite with the other residents, are all good qualities in an apartment dog.",
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    goodForNoviceOwners: {
        name: 'Good For Novice Owners',
        description: "Some dogs are simply easier than others: they take to training better and are fairly easygoing. \n    They're also resilient enough to bounce back from your mistakes or inconsistencies. Dogs who are highly sensitive, \n    independent thinking, or assertive may be harder for a first-time owner to manage. You'll get your best match if\n    you take your dog-owning experience into account as you choose your new pooch.",
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    sensitivityLevel: {
        name: 'Sensitivity Level',
        description: "Some dogs will let a stern reprimand roll off their backs, while others take even a dirty look to \n    heart. Low-sensitivity dogs, also called \"easygoing,\" \"tolerant,\" \"resilient,\" and even \"thick-skinned,\" can \n    better handle a noisy, chaotic household, a louder or more assertive owner, and an inconsistent or variable \n    routine. Do you have young kids, throw lots of dinner parties, play in a garage band, or lead a hectic life? \n    Go with a low-sensitivity dog.",
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    toleratesBeingAlone: {
        name: 'Tolerates Being Alone',
        description: "Some breeds bond very closely with their family and are more prone to worry or even panic when left \n    alone by their owner. An anxious dog can be very destructive, barking, whining, chewing, and otherwise causing \n    mayhem. These breeds do best when a family member is home during the day or if you can take the dog to work.",
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    toleratesColdWeather: {
        name: 'Tolerates Cold Weather',
        description: "Breeds with very short coats and little or no undercoat or body fat, such as Greyhounds, \n    are vulnerable to the cold. Dogs with a low cold tolerance need to live inside in cool climates and should \n    have a jacket or sweater for chilly walks.",
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    toleratesHotWeather: {
        name: 'Tolerates Hot Weather',
        description: "Dogs with thick, double coats are more vulnerable to overheating. So are breeds with short noses, \n    like Bulldogs or Pugs, since they can't pant as well to cool themselves off. If you want a heat-sensitive breed, \n    the dog will need to stay indoors with you on warm or humid days, and you'll need to be extra cautious about \n    exercising your dog in the heat.",
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    affectionateWithFamily: {
        name: 'Affectionate with Family',
        description: "Some breeds are independent and aloof, even if they've been raised by the same person since \n    puppyhood; others bond closely to one person and are indifferent to everyone else; and some shower the whole \n    family with affection. Breed isn't the only factor that goes into affection levels; dogs who were raised inside \n    a home with people around feel more comfortable with humans and bond more easily.",
        parent: profile_1.ParentBreedCharacteristic.ALL_AROUND_FRIENDLINESS
    },
    incrediblyKidFriendlyDogs: {
        name: 'Incredibly Kid Friendly Dogs',
        description: "Being gentle with children, sturdy enough to handle the heavy-handed pets and hugs they can dish out, \n    and having a blas\u00E9 attitude toward running, screaming children are all traits that make a kid-friendly dog. You \n    may be surprised by who's on that list: Fierce-looking Boxers are considered good with children, as are American \n    Staffordshire Terriers (aka pit bulls). Small, delicate, and potentially snappy dogs such as Chihuahuas aren't \n    so family-friendly.",
        parent: profile_1.ParentBreedCharacteristic.ALL_AROUND_FRIENDLINESS
    },
    dogFriendly: {
        name: 'Dog Friendly',
        description: "Friendliness toward dogs and friendliness toward humans are two completely different things. \n    Some dogs may attack or try to dominate other dogs even if they're love-bugs with people; others would rather \n    play than fight; and some will turn tail and run. Breed isn't the only factor; dogs who lived with their \n    littermates and mother until at least 6 to 8 weeks of age, and who spent lots of time playing with other dogs \n    during puppyhood, are more likely to have good canine social skills.",
        parent: profile_1.ParentBreedCharacteristic.ALL_AROUND_FRIENDLINESS
    },
    friendlyTowardStrangers: {
        name: 'Friendly Toward Strangers',
        description: "Stranger-friendly dogs will greet guests with a wagging tail and a nuzzle; others are shy, \n    indifferent, or even aggressive. However, no matter what the breed, a dog who was exposed to lots of different \n    types, ages, sizes, and shapes of people as a puppy will respond better to strangers as an adult.",
        parent: profile_1.ParentBreedCharacteristic.ALL_AROUND_FRIENDLINESS
    },
    amountOfShedding: {
        name: 'Amount of Shedding',
        description: "If you're going to share your home with a dog, you'll need to deal with some level of dog hair on \n    your clothes and in your house. However, shedding does vary greatly among the breeds: Some dogs shed year-round, \n    some \"blow\" seasonally -- produce a snowstorm of loose hair -- some do both, and some shed hardly at all. If \n    you're a neatnik you'll need to either pick a low-shedding breed, or relax your standards.",
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    droolingPotential: {
        name: 'Drooling Potential',
        description: "Drool-prone dogs may drape ropes of slobber on your arm and leave big, wet spots on your clothes \n    when they come over to say hello. If you've got a laid-back attitude toward slobber, fine; but if you're a \n    neatnik, you may want to choose a dog who rates low in the drool department.",
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    easyToGroom: {
        name: 'Easy To Groom',
        description: "Some breeds are brush-and-go dogs; others require regular bathing, clipping, and other grooming just\n     to stay clean and healthy. Consider whether you have the time and patience for a dog that needs a lot of \n     grooming, or the money to pay someone else to do it.",
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    generalHealth: {
        name: 'General Health',
        description: "Due to poor breeding practices, some breeds are prone to certain genetic health problems, such as \n    hip dysplasia. This doesn't mean that every dog of that breed will develop those diseases; it just means that \n    they're at an increased risk. If you're buying a puppy, it's a good idea to find out which genetic illnesses are \n    common to the breed you're interested in, so you can ask the breeder about the physical health of your potential \n    pup's parents and other relatives.",
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    potentialForWeightGain: {
        name: 'Potential For Weight Gain',
        description: "Some breeds have hearty appetites and tend to put on weight easily. As in humans, being overweight \n    can cause health problems in dogs. If you pick a breed that's prone to packing on pounds, you'll need to limit \n    treats, make sure he gets enough exercise, and measure out his daily kibble in regular meals rather than leaving \n    food out all the time.",
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    size: {
        name: 'Size',
        description: "Dogs come in all sizes, from the world's smallest pooch, the Chihuahua, to the towering Great Dane, \n    how much space a dog takes up is a key factor in deciding if he is compatible with you and your living space. \n    Large dog breeds might seem overpowering and intimidating but some of them are incredibly sweet! Take a look \n    and find the right large dog for you!",
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    easyToTrain: {
        name: 'Easy to Train',
        description: "Easy to train dogs are more adept at forming an association between a prompt \n    (such as the word \"sit\"), an action (sitting), and a consequence (getting a treat) very quickly. Other dogs need \n    more time, patience, and repetition during training. Many breeds are intelligent but approach training with a \n    \"What's in it for me?\" attitude, in which case you'll need to use rewards and games to teach them to want to \n    comply with your requests.",
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    },
    intelligence: {
        name: 'Intelligence',
        description: "Dogs who were bred for jobs that require decision making, intelligence, and concentration, such as \n    herding livestock, need to exercise their brains, just as dogs who were bred to run all day need to exercise\n     their bodies. If they don't get the mental stimulation they need, they'll make their own work -- usually with \n     projects you won't like, such as digging and chewing. Obedience training and interactive dog toys are good ways \n     to give a dog a brain workout, as are dog sports and careers, such as agility and search and rescue.",
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    },
    potentialForMouthiness: {
        name: 'Potential For Mouthiness',
        description: "Common in most breeds during puppyhood and in retriever breeds at all ages, mouthiness means a \n    tendency to nip, chew, and play-bite (a soft, fairly painless bite that doesn't puncture the skin). Mouthy dogs \n    are more likely to use their mouths to hold or \"herd\" their human family members, and they need training to learn \n    that it's fine to gnaw on chew toys, but not on people. Mouthy breeds tend to really enjoy a game of fetch, as \n    well as a good chew on a chew toy that's been stuffed with kibble and treats.",
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    },
    preyDrive: {
        name: 'Prey Drive',
        description: 'Willing to go after prey',
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    },
    tendencyToBarkOrHowl: {
        name: 'Tendency To Bark Or Howl',
        description: "Some breeds sound off more often than others. When choosing a breed, think about how the dog \n    vocalizes \u2014 with barks or howls \u2014 and how often. If you're considering a hound, would you find their trademark \n    howls musical or maddening? If you're considering a watchdog, will a city full of suspicious \"strangers\" \n    put him on permanent alert? Will the local wildlife literally drive your dog wild? Do you live in housing \n    with noise restrictions? Do you have neighbors nearby?",
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    },
    wanderlustPotential: {
        name: 'Wanderlust Potential',
        description: "Some breeds are more free-spirited than others. Nordic dogs such as Siberian Huskies were bred to \n    range long distances, and given the chance, they'll take off after anything that catches their interest. \n    And many hounds simply must follow their noses, or that bunny that just ran across the path, even if it \n    means leaving you behind.",
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    }
};
exports.adaptability = {
    rating: {
        value: 0,
        max: 5
    },
    name: 'Adaptability',
    children: [
        profile_1.ChildBreedCharacteristic.ADAPTS_WELL_TO_APARTMENT_LIVING,
        profile_1.ChildBreedCharacteristic.GOOD_FOR_NOVICE_OWNERS,
        profile_1.ChildBreedCharacteristic.SENSITIVITY_LEVEL,
        profile_1.ChildBreedCharacteristic.TOLERATES_BEING_ALONE,
        profile_1.ChildBreedCharacteristic.TOLERATES_COLD_WEATHER,
        profile_1.ChildBreedCharacteristic.TOLERATES_HOT_WEATHER
    ],
    adaptsWellToApartmentLiving: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    goodForNoviceOwners: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    sensitivityLevel: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    toleratesBeingAlone: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    toleratesColdWeather: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    },
    toleratesHotWeather: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.ADAPTABILITY
    }
};
exports.friendliness = {
    rating: {
        value: 0,
        max: 5
    },
    name: 'All Around Friendliness',
    children: [
        profile_1.ChildBreedCharacteristic.AFFECTIONATE_WITH_FAMILY,
        profile_1.ChildBreedCharacteristic.INCREDIBLY_KID_FRIENDLY_DOGS,
        profile_1.ChildBreedCharacteristic.DOG_FRIENDLY,
        profile_1.ChildBreedCharacteristic.FRIENDLY_TOWARD_STRANGERS
    ],
    affectionateWithFamily: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.ALL_AROUND_FRIENDLINESS
    },
    incrediblyKidFriendlyDogs: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.ALL_AROUND_FRIENDLINESS
    },
    dogFriendly: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.ALL_AROUND_FRIENDLINESS
    },
    friendlyTowardStrangers: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.ALL_AROUND_FRIENDLINESS
    }
};
exports.healthGrooming = {
    name: 'Health Grooming',
    rating: {
        value: 0,
        max: 5
    },
    children: [
        profile_1.ChildBreedCharacteristic.AMOUNT_OF_SHEDDING,
        profile_1.ChildBreedCharacteristic.DROOLING_POTENTIAL,
        profile_1.ChildBreedCharacteristic.EASY_TO_GROOM,
        profile_1.ChildBreedCharacteristic.GENERAL_HEALTH,
        profile_1.ChildBreedCharacteristic.POTENTIAL_FOR_WEIGHT_GAIN,
        profile_1.ChildBreedCharacteristic.SIZE
    ],
    amountOfShedding: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    droolingPotential: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    easyToGroom: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    generalHealth: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    potentialForWeightGain: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    },
    size: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.HEALTH_GROOMING
    }
};
exports.trainability = {
    name: 'Trainability',
    rating: {
        value: 0,
        max: 5
    },
    children: [
        profile_1.ChildBreedCharacteristic.EASY_TO_TRAIN,
        profile_1.ChildBreedCharacteristic.INTELLIGENCE,
        profile_1.ChildBreedCharacteristic.POTENTIAL_FOR_MOUTHINESS,
        profile_1.ChildBreedCharacteristic.PREY_DRIVE,
        profile_1.ChildBreedCharacteristic.TENDENCY_TO_BARK_OR_HOWL,
        profile_1.ChildBreedCharacteristic.WANDERLUST_POTENTIAL
    ],
    easyToTrain: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    },
    intelligence: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    },
    potentialForMouthiness: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    },
    preyDrive: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    },
    tendencyToBarkOrHowl: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    },
    wanderlustPotential: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.TRAINABILITY
    }
};
exports.exerciseNeeds = {
    name: 'Exercise Needs',
    rating: {
        value: 0,
        max: 5
    },
    children: [
        profile_1.ChildBreedCharacteristic.ENERGY_LEVEL,
        profile_1.ChildBreedCharacteristic.INTENSITY,
        profile_1.ChildBreedCharacteristic.EXERCISE_NEEDS,
        profile_1.ChildBreedCharacteristic.POTENTIAL_FOR_PLAYFULNESS
    ],
    energyLevel: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.EXERCISE_NEEDS
    },
    intensity: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.EXERCISE_NEEDS
    },
    exerciseNeeds: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.EXERCISE_NEEDS
    },
    potentialForPlayfulness: {
        rating: {
            value: 0,
            max: 5
        },
        parent: profile_1.ParentBreedCharacteristic.EXERCISE_NEEDS
    }
};
